import React, { useRef } from 'react';
import CodeHighlight from './../../components/code-highlight/code-highlight.jsx';
import useTemplateInteractions from './../../composables/templateInteractions.js';

function UIUnlimitedTabs() {
	const rootRef = useRef(null);
	useTemplateInteractions(rootRef);

	return (
		<div ref={rootRef}>
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-xl-10">
						<div className="row">
							<div className="col-xl-9">
								<ul className="breadcrumb">
									<li className="breadcrumb-item">
										<a href="#/">{'UI Elements'}</a>
									</li>
									<li className="breadcrumb-item active"></li>
								</ul>
								<h1 className="page-header">
									{' Unlimited Nav Tabs '}
									<small>{'page header description goes here...'}</small>
								</h1>
								<hr className="mb-4" />
								<div id="overview" className="mb-5">
									<h4>{'Overview'}</h4>
									<p>
										{' Meet '}
										<strong>{'Unlimited Nav Tabs'}</strong>
										{
											' – fully responsive on any screen, it highlights the active tab, expands when you need more space, and smartly shows or hides next/prev buttons. '
										}
									</p>
									<div className="card">
										<div className="d-flex bg-gray-900 rounded-top">
											<div className="nav-tabs-overflow">
												<ul className="nav nav-tabs nav-tabs-inverse nav-tabs-borderless">
													<li className="nav-item prev-btn">
														<a
															href="#/"
															data-click="prev-tab"
															className="nav-link text-theme"
														>
															<i className="fa fa-arrow-left mx-n1"></i>
														</a>
													</li>
													<li className="nav-item">
														<a
															href="#nav-tab-1"
															data-bs-toggle="tab"
															className="nav-link active"
														>
															{'Nav Tab 1'}
														</a>
													</li>
													<li className="nav-item">
														<a href="#nav-tab-2" data-bs-toggle="tab" className="nav-link">
															{'Nav Tab 2'}
														</a>
													</li>
													<li className="nav-item">
														<a href="#nav-tab-3" data-bs-toggle="tab" className="nav-link">
															{'Nav Tab 3'}
														</a>
													</li>
													<li className="nav-item">
														<a href="#nav-tab-4" data-bs-toggle="tab" className="nav-link">
															{'Nav Tab 4'}
														</a>
													</li>
													<li className="nav-item">
														<a href="#nav-tab-5" data-bs-toggle="tab" className="nav-link">
															{'Nav Tab 5'}
														</a>
													</li>
													<li className="nav-item">
														<a href="#nav-tab-6" data-bs-toggle="tab" className="nav-link">
															{'Nav Tab 6'}
														</a>
													</li>
													<li className="nav-item">
														<a href="#nav-tab-7" data-bs-toggle="tab" className="nav-link">
															{'Nav Tab 7'}
														</a>
													</li>
													<li className="nav-item">
														<a href="#nav-tab-8" data-bs-toggle="tab" className="nav-link">
															{'Nav Tab 8'}
														</a>
													</li>
													<li className="nav-item">
														<a href="#nav-tab-9" data-bs-toggle="tab" className="nav-link">
															{'Nav Tab 9'}
														</a>
													</li>
													<li className="nav-item">
														<a href="#nav-tab-10" data-bs-toggle="tab" className="nav-link">
															{'Nav Tab 10'}
														</a>
													</li>
													<li className="nav-item">
														<a href="#nav-tab-11" data-bs-toggle="tab" className="nav-link">
															{'Nav Tab 11'}
														</a>
													</li>
													<li className="nav-item">
														<a href="#nav-tab-12" data-bs-toggle="tab" className="nav-link">
															{'Nav Tab 12'}
														</a>
													</li>
													<li className="nav-item">
														<a href="#nav-tab-13" data-bs-toggle="tab" className="nav-link">
															{'Nav Tab 13'}
														</a>
													</li>
													<li className="nav-item">
														<a href="#nav-tab-14" data-bs-toggle="tab" className="nav-link">
															{'Nav Tab 14'}
														</a>
													</li>
													<li className="nav-item">
														<a href="#nav-tab-15" data-bs-toggle="tab" className="nav-link">
															{'Nav Tab 15'}
														</a>
													</li>
													<li className="nav-item next-btn">
														<a
															href="#/"
															data-click="next-tab"
															className="nav-link text-theme"
														>
															<i className="fa fa-arrow-right mx-n1"></i>
														</a>
													</li>
												</ul>
											</div>
											<div className="me-2 ms-2 d-flex align-items-center">
												<a
													href="#/"
													className="btn btn-xs btn-icon d-flex align-items-center justify-content-center btn-secondary"
													data-toggle="panel-expand"
												>
													<i className="fa fa-expand"></i>
												</a>
											</div>
										</div>
										<div className="card-body tab-content">
											<div className="tab-pane fade active show" id="nav-tab-1">
												<h3>{'Nav Tab 1'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-2">
												<h3>{'Nav Tab 2'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-3">
												<h3>{'Nav Tab 3'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-4">
												<h3>{'Nav Tab 4'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-5">
												<h3>{'Nav Tab 5'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-6">
												<h3>{'Nav Tab 6'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-7">
												<h3>{'Nav Tab 7'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-8">
												<h3>{'Nav Tab 8'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-9">
												<h3>{'Nav Tab 9'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-10">
												<h3>{'Nav Tab 10'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-11">
												<h3>{'Nav Tab 11'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-12">
												<h3>{'Nav Tab 12'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-13">
												<h3>{'Nav Tab 13'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-14">
												<h3>{'Nav Tab 14'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-15">
												<h3>{'Nav Tab 15'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-16">
												<h3>{'Nav Tab 16'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-17">
												<h3>{'Nav Tab 17'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-18">
												<h3>{'Nav Tab 18'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-19">
												<h3>{'Nav Tab 19'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
											<div className="tab-pane fade" id="nav-tab-20">
												<h3>{'Nav Tab 20'}</h3>
												<p>
													{
														' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ac dui eu felis hendrerit lobortis. Phasellus elementum, nibh eget adipiscing porttitor, est diam sagittis orci, a ornare nisi quam elementum tortor. Proin interdum ante porta est convallis dapibus dictum in nibh. Aenean quis massa congue metus mollis fermentum eget et tellus. Aenean tincidunt, mauris ut dignissim lacinia, nisi urna consectetur sapien, nec eleifend orci eros id lectus. '
													}
												</p>
												<p>
													{
														' Aenean eget odio eu justo mollis consectetur non quis enim. Vivamus interdum quam tortor, et sollicitudin quam pulvinar sit amet. Donec facilisis auctor lorem, quis mollis metus dapibus nec. Donec interdum tellus vel mauris vehicula, at ultrices ex gravida. Maecenas at elit tincidunt, vulputate augue vitae, vulputate neque. Aenean vel quam ligula. Etiam faucibus aliquam odio eget condimentum. Cras lobortis, orci nec eleifend ultrices, orci elit pellentesque ex, eu sodales felis urna nec erat. Fusce lacus est, congue quis nisi quis, sodales volutpat lorem. '
													}
												</p>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="html"
													src="/color-admin/admin/react/assets/data/ui-unlimited-tabs/code-1.json"
												/>
											</pre>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xl-3">
								<nav
									data-init="scrollspy"
									className="navbar navbar-sticky navbar-sticky-start d-none d-xl-block py-4 h-100"
								>
									<nav className="nav">
										<a className="nav-link active" href="#overview" data-toggle="scroll-to">
											{'Overview'}
										</a>
										<hr />
										<div className="nav-link pe-0 pt-2">
											<div className="mb-3">
												<b className="badge bg-gray-800 d-inline-flex align-items-center px-2 py-6px">
													<i className="fa fa-circle fa-fw fs-6px text-teal me-1"></i>
													<i className="fa fa-circle fa-fw fs-6px text-warning me-1"></i>
													<i className="fa fa-circle fa-fw fs-6px text-danger me-2"></i>
													{' Main Features '}
												</b>
											</div>
											<div className="alert alert-secondary py-6px px-10px lh-14 small mb-3">
												<i className="fa fa-info-circle fa-fw"></i>
												{' Unlimited Navigation Tabs is '}
												<b>{'not compatible'}</b>
												{' with the bootstrap dropdown menu. '}
											</div>
											<div className="d-flex flex-column gap-3 text-body">
												<div className="d-flex gap-2">
													<div className="fs-2 text-muted w-35px h-35px d-flex justify-content-center align-items-center">
														<iconify-icon icon="solar:laptop-minimalistic-bold-duotone"></iconify-icon>
													</div>
													<div className="small">
														<b>{'Responsive'}</b>
														<br />
														{'in any screen size'}
													</div>
												</div>
												<div className="d-flex gap-2">
													<div className="fs-2 text-muted w-35px h-35px d-flex justify-content-center align-items-center">
														<iconify-icon icon="solar:eye-bold-duotone"></iconify-icon>
													</div>
													<div className="small">
														<b>{'Autofocus'}</b>
														<br />
														{'on active tabs'}
													</div>
												</div>
												<div className="d-flex gap-2">
													<div className="fs-3 text-muted w-35px h-35px d-flex justify-content-center align-items-center">
														<iconify-icon icon="solar:full-screen-bold-duotone"></iconify-icon>
													</div>
													<div className="small">
														<b>{'Card Expand'}</b>
														<br />
														{'features supported'}
													</div>
												</div>
												<div className="d-flex gap-2">
													<div className="fs-3 text-muted w-35px h-35px d-flex justify-content-center align-items-center">
														<iconify-icon icon="solar:settings-bold-duotone"></iconify-icon>
													</div>
													<div className="small">
														<b>{'Auto'}</b>
														<br />
														{' Show / Hide Button'}
													</div>
												</div>
												<div className="d-flex gap-2">
													<div className="fs-3 text-muted w-35px h-35px d-flex justify-content-center align-items-center">
														<iconify-icon icon="solar:sun-2-bold-duotone"></iconify-icon>
													</div>
													<div className="small">
														<b>{'Light / Dark'}</b>
														<br />
														{' Mode Supported'}
													</div>
												</div>
											</div>
										</div>
									</nav>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default UIUnlimitedTabs;
